import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Synchronous utility function with comprehensive error handling
export function cn(...inputs) {
    try {
        // Check if clsx and twMerge are available
        if (typeof clsx !== 'undefined' && typeof twMerge !== 'undefined') {
            return twMerge(clsx(inputs));
        }
        
        // Fallback: safe class name joining with proper type checking
        return inputs?.filter(input => input !== null && input !== undefined && input !== false && input !== '')?.map(input => {
                if (typeof input === 'string') {
                    return input;
                }
                if (typeof input === 'number') {
                    return String(input);
                }
                if (typeof input === 'object' && input !== null) {
                    // Handle objects like { 'class-name': true, 'other-class': false }
                    return Object.entries(input)?.filter(([, value]) => Boolean(value))?.map(([key]) => key)?.join(' ');
                }
                if (Array.isArray(input)) {
                    // Recursively handle arrays
                    return cn(...input);
                }
                // Convert any other type to string safely
                return String(input);
            })?.join(' ')?.replace(/\s+/g, ' ')?.trim();
    } catch (error) {
        console.warn('cn utility error:', error);
        // Ultimate fallback - safely convert all inputs to strings
        return inputs?.filter(input => input !== null && input !== undefined && input !== false && input !== '')?.map(input => {
                try {
                    return String(input);
                } catch {
                    return '';
                }
            })?.filter(str => str?.length > 0)?.join(' ')?.replace(/\s+/g, ' ')?.trim();
    }
}

// Alias for backward compatibility
export const cnSync = cn;

// Default export
export default cn;